import request from '@/router/axios'

const withTruckInboundType = (row = {}) => {
  return { businessType: 3, planType: 2, status: 1, ...row }
}

export const getList = (params = {}) => {
  return request({
    url: '/api/produce/transport-plan/selectM/page',
    method: 'post',
    data: withTruckInboundType(params)
  })
}

export const planStockAmountTotal = (data = {}) => {
  return request({
    url: '/api/produce/transport-plan/planStockAmountTotal',
    method: 'post',
    data: withTruckInboundType({ stockQuery: 0, ...data })
  })
}

export const getCustNoList = (params = {}) => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  })
}
